<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-09 23:12:00
 * @LastEditTime: 2025-09-27 23:19:43
-->
<template>
    <div class="tool">

      <div class="title-block">
        <van-button type="info" block @click="show = true" icon="search">文职岗位筛选</van-button>
      </div>

      <main style="margin-top: 66px;">
        <listPost type="intelligencePost" :form="form" ref="listPost" :key="key"></listPost>
      </main>
      
      <van-tabbar v-model="active">
        <van-tabbar-item icon="orders-o"
          >岗位筛选</van-tabbar-item
        >
        <van-tabbar-item icon="apps-o" @click="toUrl('/serviceIntelligencePost')"
          >智能匹配</van-tabbar-item
        >
        <van-tabbar-item icon="manager-o" @click="toUrl('/servicePostMyCollect')"
          >我的收藏</van-tabbar-item
        >
      </van-tabbar>



      <van-overlay :show="digshow">
            <div class="wrapper" @click.stop>
                <div class="block">
                <div class="dig_titile">文职岗位筛选</div>
                <van-form @submit="onSubmit" style="width: 90%;margin: 0 auto;margin-top: 40px;">
                    <div style="line-height: 30px;font-weight: bold;" class="roule">手机号：</div>
                    <van-field v-model="phone" placeholder="请输入您的报考手机号"
                    style="border: 1px #ebedf0 solid;border-radius: 10px;" />
                    <div style="margin: 16px;margin-top: 30px;">
                    <van-button round block type="danger" native-type="submit" :loading="isbtn">登录</van-button>
                    </div>
                </van-form>
                <div class="text1">学员请输入报名手机号使用,验证无权限请联系班主任老师开通权限！</div>
                </div>
            </div>
      </van-overlay>

      <van-action-sheet v-model="show">
        <div class="content-action">
          <!-- <van-field v-model="form.companyOrPostName"  placeholder="根据岗位名称搜索" /> -->
          <van-field v-model="form.positionCode"  placeholder="根据岗位代码搜索" />
          <div style="display: flex;align-items: center;">
              <van-field v-model="form.major[0]"  placeholder="请输入专业关键字"/>
          </div>
          
          <div class="item">
            <p>学历</p>
            <ul>
              <li v-for="(item, index) in educationNewList" :key="index"
                @click="handle('educationalBackground', item, index, 'educationNewListIndex')"
                :class="educationNewListIndex == index ? 'active' : ''">
                {{ item.text }}
              </li>
            </ul>
          </div>
          <div class="item">
            <p>学位</p>
            <ul>
              <li v-for="(item, index) in academicDegree" :key="index"
                @click="handle('degree', item, index, 'academicDegreeIndex')"
                :class="academicDegreeIndex == index ? 'active' : ''">
                {{ item.text }}
              </li>
            </ul>
          </div>
          <div class="item">
            <p>身份类别</p>
            <ul>
              <li v-for="(item, index) in comeType" :key="index"
                @click="handle('sourceCategory', item, index, 'comeTypeIndex', 'text')"
                :class="comeTypeIndex == index ? 'active' : ''">
                {{ item.text }}
              </li>
            </ul>
          </div>
          <van-field v-model="form.workPlace[0]"  placeholder="工作地点" />


          <div style="display:flex; justify-content: space-between;margin-top: 20px;">
              <van-button type="default" round  @click="reset" style="width: 45%">重置</van-button>
              <van-button type="info" round  @click="confirmSubmit" style="width: 45%;background-color: rgb(20,65,134);border: none;">确定</van-button>
          </div>
        </div>
    </van-action-sheet>
    
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import { companyList, getDictType, authorityList } from '@/api/xicaiquan'
  import listPost from "@/views/servicePost/component/listPost.vue"
  import { Image as VanImage, Tabbar, TabbarItem, Toast, ActionSheet } from 'vant'
  import axios from 'axios'
  Vue.use(VanImage)
  Vue.use(Tabbar)
  Vue.use(TabbarItem)
  Vue.use(ActionSheet)
  export default {
    name: 'servicePost',
    data () {
      return {
        active: 0,
        icon: {
          active: 'https://img01.yzcdn.cn/vant/user-active.png',
          inactive: 'https://img01.yzcdn.cn/vant/user-inactive.png'
        },
        key: '',
        notices: [],
        digshow: true,
        show: false,
        isbtn:false,
        phone: '',
        queryParams: {
          current: 1,
          size: 10,
          companyName: ''
        },
        listData: [],
        companyMoldList: [],
        companyScaleList: [],
        companyTypeList: [],
        educationNewList: [], // 学历
        educationNewListIndex: -1,
        academicDegree:[],
        academicDegreeIndex: -1,
        comeType: [],
        comeTypeIndex: -1,
        form: {
          workPlace: [],
          major: [],
          degree: '',
          educationalBackground: '',
          sourceCategory: '',
          positionCode: '',
        }
      }
    },
    created () {
      // Promise.all([
      //   this.getDictType('company_mold', 'companyMoldList'),
      //   this.getDictType('company_scale', 'companyScaleList'),
      //   this.getDictType('company_company_type', 'companyTypeList')
      // ]).then(res => {

      // })

      this.getDictType("education", "educationNewList")
      this.getDictType("academic_degree", "academicDegree")
      this.getDictType("come_type", "comeType")

      if (!sessionStorage.getItem("service_phone")) {
       this.digshow = true;
      } else {
        this.digshow = false;
      }
    },
    components: {
      listPost
    },
    watch: {},
    methods: {
      // async fetchNotices () {
      //   try {
      //     const response = await axios.get(
      //       'https://api4.iguopin.com/api/notice/list',
      //       {
      //         params: {
      //           page: 1,
      //           per_page: 20,
      //           type: 'sasac',
      //           keyword: '' // 根据需要填写关键词，如果为空则留空字符串
      //         }
      //       }
      //     )
      //     this.notices = response.data
      //   } catch (error) {
      //     console.error('Error fetching notices:', error)
      //   }
      // },
      // filteredItems(arr) {
      //     // console.log(arr, '传输数据')
      //     return arr.filter(item => !item.raw.listClass.includes('default'));
      // },
      handle(type, item, index, typeIndex, itemValueKey) {
            this.form[type] = itemValueKey ? item[itemValueKey] : item.value
            // this.form[type].push(item.value)
            this[typeIndex] = index;
      },
      getPostStatus (target, prop, row) {
        const item = this[target].find(item => item.value == row[prop])
  
        if (item) {
          return item.text
        } else {
          return '无'
        }
      },
      async getDictType (type, target, callback) {
        return new Promise(async (resolve, reject) => {
          const res = await getDictType(type)
          if (res.code == 200) {
            resolve()
            res.data.forEach(item => {
              if (!item.listClass.includes('default')) {
                this[target].push({
                  text: item.dictLabel,
                  value: item.dictValue
                })
              }
            })
          } else {
            reject()
          }
        })
      },
      async onSubmit() {
        if (this.phone == '') { return Toast('请填写手机号') }
        this.isbtn = true
        const res = await authorityList({ mobile: this.phone })
        this.isbtn = false;
        if (res.data) {
          sessionStorage.setItem("service_phone", this.phone)
          this.digshow = false;
          this.key = new Date().getTime()
        } else {
          Toast(res.msg)
        }
      },
      reset() {

        this.form.workPlace = []
        this.form.major = []
        this.form.degree = ''
        this.form.educationalBackground = ''
        this.form.sourceCategory = ''
        this.form.positionCode = ''

        this.$refs.listPost.queryParams.current = 1;

        this.educationNewListIndex = -1
        this.academicDegreeIndex = -1
        this.comeTypeIndex = -1
        this.show = false;

        document.documentElement.scrollTop=0
        window.pageYOffset=0  
        document.body.scrollTop=0

        this.key = new Date().getTime()
        // this.$refs.listPost.loadData()

      },
      confirmSubmit() {
        this.show = false;
        this.$refs.listPost.queryParams.current = 1;

        this.key = new Date().getTime()
        // this.$refs.listPost.loadData()
      },
      toUrl (path) {
        this.$router.replace({ path })
      }
    }
  }
  </script>
  <style scoped lang="scss">
  
  .van-tabbar {
    width: 100vw;
  }

  .title-block {
    height: 60px;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    background: #fff;
    z-index: 100;
    padding: 10px;
  }

  .text {
    width: 100%;
    background-color: white;
    font-size: 20px;
    // line-height: 40px;
    font-weight: bold;
    padding: 16px 10px;
    padding-top: 18px;
    margin-bottom: 30px;
    // padding-bottom: 200px;
  }
  .min_box {
    width: 100%;
    margin: 0 auto;
    padding: 0 5px;
    padding-top: 18px;
    background-color: white;
    .min_item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      justify-items: center;
    }
  }
  
  .icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    font-size: 40px;
  }
  
  .tool {
    width: 100%;
    height: 100vh;
    background: #f3f6f9;
  
    .content {
      width: 95%;
      height: 300px;
      border-radius: 10px;
      background: #fff;
      margin: 30px auto;
  
      ul {
        display: flex;
  
        li {
          width: 80px;
          height: 50px;
          // box-shadow: 0px 0px 0px 1px #ddd;
          text-align: center;
          // line-height: 50px;
          margin-right: 10px;
          margin-top: 50px;
        }
      }
    }
  }


.wrapper {
  display: flex;
  // align-items: center;
  margin-top: 20vh;
  justify-content: center;
  // height: 100%;
}

.dig_titile {
  font-size: 16px;
  line-height: 50px;
  width: 100%;
  text-align: center;
  color: rgb(224, 32, 32);
  font-weight: bold;
}

.text1 {
  width: 90%;
  margin: 0 auto;
  text-align: center;
  line-height: 20px;
  margin-top: 40px;
  color: #969799;
}

.block {
  width: 90%;
  // height: 40vh;
  // height: 40%;
  background-color: #fff;
  border-radius: 10px;
  padding-bottom: 40px;
}

.active {
  background: #eaf4ff;
  color: #5ca3fe;
  font-weight: bold;
}

.van-overlay {
  z-index: 999;
}

.content-action {
  padding: 30px 20px;

  /deep/ .van-cell {
    margin: 6px 0px;
    border: 1px solid #ddd;
    border-radius: 10px;
  }

  .item {
    margin: 14px 0px;

    p {
      font-size: 15px;
      margin: 10px;
    }

    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        margin: 0px 4px;
        width: fit-content;
        padding: 0px 6px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        background: #f5f8fa;
        margin-bottom: 10px;
      }
    }
  }
}
  </style>
  